import {ErrorDefault, ErrorMustBeMember} from './Errors.ts'
import {HTTPStatus} from './ErrorEnums.ts'
import {getNestedTranslation, type TranslationObject} from '@colonist/i18n'

function createErrorAndPurchaseMembershipPrompt(errorMessage: TranslationObject): TranslationObject {
    return getNestedTranslation({
        key: 'strings:popups.errors.replay.errorAndMembershipPrompt',
    }, {
        errorMessage: errorMessage,
        membershipPrompt: {key: 'strings:popups.errors.replay.storePurchaseMembershipPrompt'},
    })
}

function createErrorAndUpgradeMembershipPrompt(errorMessage: TranslationObject): TranslationObject {
    return getNestedTranslation({
        key: 'strings:popups.errors.replay.errorAndMembershipPrompt',
    }, {
        errorMessage: errorMessage,
        membershipPrompt: {key: 'strings:popups.errors.replay.storeUpgradeMembershipPrompt'},
    })
}

export namespace ErrorReplay {
    export class InvalidPlayerColor extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.replay.invalidPlayerColor'}
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class InvalidGameId extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.replay.invalidGameId'}
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class InvalidUrlSlug extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.replay.invalidUrlSlug'}
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class GameNotFound extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.replay.gameNotFound'}
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class UserNotInGame extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.replay.userNotInGame'}
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class NoMembershipTryingToCreateReplayLink extends ErrorMustBeMember {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message = createErrorAndPurchaseMembershipPrompt({key: 'strings:popups.errors.replay.noMembershipTryingToCreateReplayLink'})
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class NoMembershipTryingToWatchOwnReplay extends ErrorMustBeMember {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message = createErrorAndPurchaseMembershipPrompt({key: 'strings:popups.errors.replay.noMembershipTryingToWatchOwnReplay'})
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class NoMembershipTryingToWatchAnotherPlayerReplay extends ErrorMustBeMember {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message = createErrorAndPurchaseMembershipPrompt({key: 'strings:popups.errors.replay.noMembershipTryingToWatchAnotherPlayerReplay'})
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class NoMembershipTryingToChangeReplayPerspective extends ErrorMustBeMember {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message = createErrorAndPurchaseMembershipPrompt({key: 'strings:popups.errors.replay.noMembershipTryingToChangeReplayPerspective'})
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class InvalidMembershipTryingToWatchAnotherPlayerReplay extends ErrorMustBeMember {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message = createErrorAndPurchaseMembershipPrompt({key: 'strings:popups.errors.replay.invalidMembershipTryingToWatchAnotherPlayerReplay'})
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class PlusMembershipReplayLimitReached extends ErrorMustBeMember {
        constructor(limit: number) {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message = createErrorAndUpgradeMembershipPrompt({key: 'strings:popups.errors.replay.plusMembershipLimitReach', options: {limit: limit}})
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class InvalidMembership extends ErrorMustBeMember {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.replay.title'}
            const message = createErrorAndUpgradeMembershipPrompt({key: 'strings:popups.errors.replay.invalidMembership'})
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }
}
